import React, { forwardRef } from 'react';
import { CtaButton } from './CtaButton';
import { images } from '../data/content';
type HeroProps = {
  onCtaClick: () => void;
};
export const Hero = forwardRef<HTMLElement, HeroProps>(function Hero({
  onCtaClick
}, ref) {
  return <header ref={ref} className="bg-gradient-to-b from-ink to-wine px-6 pb-14 pt-12 text-center" data-id="element-72" data-mp="9ipbb96819z2">
      <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-gold" data-id="element-73" data-mp="4jm5hmif2zq1">
        MSc Beatriz Espina · La DOC
      </p>
      <h1 className="mt-6 font-serif text-[40px] font-bold leading-[1.08] text-white" data-id="element-74" data-mp="xanqi48sjphh">
        En 30 días, aprendes a ser una <span className="text-gold" data-id="element-75" data-mp="sai3j1dgur5q">Estratega</span>.
      </h1>
      <p className="mx-auto mt-5 max-w-[340px] text-base leading-relaxed text-muted" data-id="element-76" data-mp="nc88cqrqrqk4">
        Segura. Irresistible. Vista, al punto de tenerlo a sus pies.
      </p>
      <img src={images.cover} alt="Portada del programa ELEGIDA con la MSc Beatriz Espina" className="mt-9 aspect-square w-full rounded-xl object-cover" data-id="element-77" data-mp="3d33fj0i70xlt" />
      <div className="mt-8" data-id="element-78" data-mp="3j9u2j3pddwnx">
        <CtaButton label="Quiero entender por qué" onClick={onCtaClick} showGuarantee={false} data-id="element-79" data-mp="3j6fxtot8hbdb" />
      </div>
    </header>;
});